import { useAuth0 } from '@auth0/auth0-react';
import { AppLogo, Button, Dropdown, DropdownText, Icons, useDropdown } from '@serodigital/ui-components';
import * as React from 'react';

export const Shell = (props: JSX.IntrinsicElements['div']) => {
  const { open, isOpen } = useDropdown();
  const { user, logout } = useAuth0();
  return (
    <div data-qa="shell" className="flex sero-flex-col h-screen">
      <div className="sero-bg-grey-background-1 flex flex-row">
        <header className="pt-12 w-full flex flex-row items-center justify-between px-32 h-108">
          <div className="ml-32">
            <AppLogo appName="bee admin" data-qa="bee-admin-logo" />
          </div>
          <Dropdown
            button={
              <Button data-qa="bee-admin-user-button" kind="tertiary" size="small" icon="right" onClick={open}>
                Hello, {user?.given_name || user?.nickname}
                {isOpen ? <Icons.ChevronUp /> : <Icons.ChevronDown />}
              </Button>
            }
          >
            <DropdownText data-qa="bee-admin-logout" onClick={logout}>
              Sign out
            </DropdownText>
          </Dropdown>
        </header>
      </div>
      <main className="flex flex-1 flex-col kieran-was-ere-2k22">{props.children}</main>
    </div>
  );
};
